import React from "react";
import { sanitizeHtml } from "../../utils/sanitize";
import { FieldGroup } from "../FieldGroup/FieldGroup";
import {
  FieldContainer,
  FieldLabel,
  FieldLabelXs,
  FieldSeparator,
  FieldWrapper,
} from "../../sections/DynamicForm/DynamicForm.styles";
import { FormSpanError, PrivacyPolicy } from "../FormBuilder/FormBuilder.styles";
import { FormElement } from "../../sections/DynamicForm/DynamicForm.types";

interface CheckboxGroupProps {
  element: FormElement;
  commonProps: any;
  formStyles: any;
  privacyPolicy: string;
  handleFieldChange: (fieldName: string) => void;
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  element,
  commonProps,
  formStyles,
  privacyPolicy,
  handleFieldChange,
}) => {
  const { props } = element;
  const { label, attribute_name, options, validation } = props;
  const fieldName = attribute_name;

  const isPrivacyPolicy = attribute_name === "dataPermissions";

  if (isPrivacyPolicy) {
    return (
      <FieldContainer key={commonProps.id}>
        <FieldSeparator />
        <FieldLabelXs
          color={formStyles?.textColor}
          style={{ alignItems: "flex-start" }}
        >
          <input
            type="checkbox"
            name={attribute_name}
            onChange={() => fieldName && handleFieldChange(fieldName)}
            required={validation?.required}
          />
          <PrivacyPolicy
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(props.text || privacyPolicy) }}
            style={{ color: formStyles?.textColor }}
            className="rich-text-reset-html"
          />
        </FieldLabelXs>
        {commonProps.error && (
          <FormSpanError>{commonProps.helperText}</FormSpanError>
        )}
      </FieldContainer>
    );
  }

  return (
    <FieldGroup
      key={commonProps.id}
      title={label}
      colorTitle={formStyles?.textColor}
    >
      <FieldWrapper>
        {options?.map((option: { value: string; label: string }) => (
          <FieldLabel key={option.value} color={formStyles?.textColor}>
            <input
              type="checkbox"
              name={`${attribute_name}[]`}
              value={option.value}
              onChange={() => fieldName && handleFieldChange(fieldName)}
            />
            {option.label}
          </FieldLabel>
        ))}
      </FieldWrapper>
      {commonProps.error && (
        <FormSpanError>{commonProps.helperText}</FormSpanError>
      )}
    </FieldGroup>
  );
};
